import React from 'react';

import {
  Grid, Typography, Card, Link,
} from '@material-ui/core';
import Layout from '../components/layout';
import Image from '../components/image';
import SEO from '../components/seo';
import Assets from '../images/assets';

const apps = [
  {
    name: '便秘スッキリカレンダー',
    icon: 'app_bs.png',
    description: '簡単操作の便秘スッキリ記録アプリです。腸内環境を整えることは、美肌・ダイエット・老化防止にと良いことが沢山です。\n一緒に便秘解消を目指しましょう。',
    google_id: 'com.h2acreate.bs',
    appstore_id: '1071616084',
  },
  {
    name: 'お薬記録 & アラーム',
    icon: 'app_medicine.png',
    description: '必要な機能だけを、わかりやすくシンプルに。\n複雑な操作が苦手な人にぜひ試してもらいたい、薬の記録管理＆アラームアプリです。',
    google_id: 'net.futasaji.medicine',
    appstore_id: '1552171774',
  },
  {
    name: 'らくらく献立表',
    icon: 'app_meal.png',
    description: '毎日の献立は、らくらく献立表に任せちゃいましょう。\n毎日の献立を簡単に作成できます。',
    google_id: 'net.futasaji.meal',
    appstore_id: '1612213187',
  },
];
const IndexPage = () => {
  const headerBottom = (
    <div>
      <div style={{ position: 'relative', width: '100%', height: 420 }}>
        <img
          height="100%"
          width="100%"
          src={Assets.main_visual}
          alt="test"
          style={{
            position: 'absolute',
            right: 0,
            objectFit: 'contain',
            zIndex: -1,
          }} />

      </div>
      <Typography
        align="center"
        variant="h5"
        style={{
          padding: 40,
          marginTop: -40,
          backgroundColor: '#FFFFFFDD',
        }}>
        アプリで生活を豊かに
      </Typography>
      <hr />
    </div>
  );

  return (
    <Layout headerBottom={headerBottom}>
      <SEO title="合同会社ふたさじ" description="「アプリで生活を豊かに」をテーマにAndroid・iPhoneアプリの提供を行っています。" />
      <Typography
        align="center"
        variant="h5"
        style={{
          marginTop: 28, marginBottom: 40, color: '#666', fontWeight: 600,
        }}>Apps
      </Typography>
      <Grid
        spacing={1}
        container>
        {apps.map((app) => <Row app={app} />)}
      </Grid>
      <Typography
        align="center"
        variant="h5"
        style={{
          marginTop: 120, marginBottom: 40, color: '#666', fontWeight: 600,
        }}>Media
      </Typography>
      <Grid
        container
        direction="column"
        alignItems="center">
        <Link href="https://mogu2.as-media.page" target="_blank">
          <img
            src={Assets.media_mogu2}
            alt="あずの毎日おうちごはん"
            style={{
              width: '100%', maxWidth: 640, boxShadow: '0px 0px 8px -4px rgba(0,0,0,0.6)', borderRadius: 4,
            }} />
        </Link>
      </Grid>
    </Layout>
  );
};

const Row = ({ app }) => (
  <Grid
    item
    xs={12}
    md={6}>
    <Card style={{
      flex: 1, padding: '5%', display: 'flex', flexDirection: 'row', height: '100%',
    }}>
      <Image style={{ width: 72, height: 72, borderRadius: 10 }} filename={app.icon} />
      <div style={{ flex: 1, marginLeft: '5%' }}>
        <Typography gutterBottom variant="h6">{app.name}</Typography>
        <Typography display="block" gutterBottom variant="body2" style={{ color: '#555', marginTop: 16 }}>
          {app.description}
        </Typography>
        <div style={{
          marginTop: 24, height: '4.8vh', flex: 1, flexDirection: 'row',
        }}>
          <Link href={`https://itunes.apple.com/jp/app/id${app.appstore_id}?mt=8`}>
            <img src={Assets.appstore_badge} alt="appstore_badge" style={{ width: '40%', maxWidth: 120, marginRight: 6 }} />
          </Link>
          <Link href={`https://play.google.com/store/apps/details?id=${app.google_id}`}>
            <img src={Assets.google_play_badge} alt="google_play_badge" style={{ width: '50%', maxWidth: 150 }} />
          </Link>
        </div>
      </div>
    </Card>
  </Grid>
);

export default IndexPage;
